__turbopack_context__.v({
  "miniToolbar": "AcmnbW_miniToolbar",
  "talkBubble": "AcmnbW_talkBubble",
});
